import {
  stringDecoder,
  objectDecoder,
  arrayDecoder,
  Decoder,
} from "json-decoder";
import { Error } from "../domain/error";
import { ErrorJson } from "../types/types";

export const errorJsonDecoder =
  objectDecoder<ErrorJson.Properties.Errors.Items>({
    errorCode: stringDecoder,
    message: stringDecoder,
  });

export const errorsDecoder = objectDecoder<ErrorJson>({
  errors: arrayDecoder(errorJsonDecoder),
});

export const errorConverter = (
  errorJson: ErrorJson.Properties.Errors.Items
): Error => ({
  code: errorJson.errorCode,
  description: errorJson.message,
});

export const errorDecoder: Decoder<Error> = errorsDecoder.map(
  (errorJson) =>
    ({
      code: errorJson.errors[0].errorCode,
      description: errorJson.errors[0].message,
    }) as Error
);
